import { ITemplateModel } from "@/components/template/models";

export enum ESopTab {
    Standard,
    Template,
}

export enum ETechnology{
    Step = "centrifuge",
    Spls = "spoc",
    Cat = "fracture"
}

export interface IDeviceClassGroup {
    header: React.ReactChild;
    id: string;
}

export interface IDeviceClassItemGroup extends IDeviceClassGroup{
    items: ITemplateModel[];
}